import {createFileRoute} from '@tanstack/react-router';

import ContactForm from '@/shared/views/contact/ContactForm';

export const Route = createFileRoute('/(shared)/contact')({
  component: ContactForm
});
